import React from "react";

import cx from "classnames";

import { Text, TextSizes } from "../Text";

import styles from "./Link.scss";

export interface LinkProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  /** Where to open the linked document */
  target?: "_self" | "_blank" | "_parent" | "_top";
  /** Additional styling for this component */
  className?: string;
  /** Specifies the destination of this link */
  to: string;
  /** For better SPA experience */
  linkElement?: React.ComponentType<any>;
  /** Size applied to Text component */
  textSize?: TextSizes;
  /** Paragraph styling applied to inner Text component */
  paragraph?: boolean;
}

/**
 * A styled link component. It can be a simple anchor or `Link` component from 'react-router-dom' when passing linkElement
 */
export function Link({
  to,
  children,
  linkElement: RouterLink,
  className,
  target,
  textSize,
  paragraph = false,
  ...anchorProps
}: LinkProps): JSX.Element | null {
  if (!children) {
    return null;
  }

  const linkClasses = cx(styles.link, className);

  if (!RouterLink) {
    return (
      <Text size={textSize} paragraph={paragraph}>
        <a
          {...anchorProps}
          href={to}
          className={linkClasses}
          target={target}
          rel={target === "_blank" ? "noopener noreferrer" : anchorProps.rel}
        >
          {children}
        </a>
      </Text>
    );
  }

  return (
    <Text size={textSize} paragraph={paragraph}>
      <RouterLink
        {...anchorProps}
        to={to}
        className={linkClasses}
        target={target}
        rel={target === "_blank" ? "noopener noreferrer" : anchorProps.rel}
      >
        {children}
      </RouterLink>
    </Text>
  );
}
